import { makeStyles } from '@material-ui/core/styles';
import { CustomTheme } from '../../Custom/types';
import { white } from '../../Custom/Colors';

export const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    root: {},
    Buttongroup: {
      boxShadow: 'none !important',
      padding: theme.spacing(0.75, 0),
      display: 'flex',
    },
    removeButton: {
      minWidth: 'auto !important',
      borderBottomLeftRadius: `0px !important`,
      borderTopLeftRadius: `0px !important`,
      borderBottomRightRadius: `4px !important`,
      borderTopRightRadius: `4px !important`,
      height: '48px !important',
      width: '48px !important',
      boxShadow: 'none !important',
    },
    addButton: {
      minWidth: 'auto !important',
      borderBottomLeftRadius: `4px !important`,
      borderTopLeftRadius: `4px !important`,
      borderBottomRightRadius: `0px !important`,
      borderTopRightRadius: `0px !important`,
      height: '48px !important',
      width: '48px !important',
      boxShadow: 'none !important',
    },
    textInput: {
      pointerEvents: 'auto',
      width: '80px',
      height: '48px',
      paddingHorizontal: '16px',
      backgroundColor: white,
      '& input[type=number]': {
        MozAppearance: 'textfield',
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '& input': {
        textAlign: 'center',
      },
    },
    title: {
      fontWeight: 'normal',
      marginBottom: 0,
    },
    inputHintError: {
      color: theme.palette.error.main,
      whiteSpace: 'pre-line',
    },
    inputHint: {
      whiteSpace: 'pre-line',
    },
  };
});
